import dompurify from 'dompurify';
import { emsSessionIdHeaderKey, httpUtils } from '../../web/common/apis/httpUtils';

export const sanitizeHTML = (text: string, allowedAttrs?: string[]): string =>
  dompurify.sanitize(text, { ADD_ATTR: allowedAttrs });

export const appendEmsSessionIdQueryParameter = (link: string) => {
  const emsSessionId = httpUtils.getEmsSessionId();

  if(!!emsSessionId) {
    const joiner = link.includes('?') ? '&' : '?';
    const emsSessionIdQueryParameter = `${joiner}${emsSessionIdHeaderKey}=${emsSessionId}`;
    link = link.concat(emsSessionIdQueryParameter);
  }

  return link;
}

export const inEmsSession = () => {
  const emsSessionId = httpUtils.getEmsSessionId();

  return !!emsSessionId;
}
